import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import API from '../../API';

/**
 * Display to show / select services (legal, housing, etc.) that the user is interested in seeing in app, and hearing about
 * @param {*} props 
 * @author BrianCastor
 */
export default function ServicesSelector(props) {
  const field = 'Services_MPL__c';
  const [selectedServices, setSelectedServices] = React.useState(props.userData[field] || []);
  const serviceOptions = API.getAllServiceCategories();

  React.useEffect(() => {
    let newData = {}
    newData[field] = selectedServices;
    props.updateUserData(newData);
  }, [])

  function handleToggle(serviceName) {
    let temp = [...selectedServices];
    if (temp.includes(serviceName)) {
      temp.splice(temp.indexOf(serviceName), 1)
      setSelectedServices(temp);
    }
    else {
      temp.push(serviceName);
      setSelectedServices(temp);
    }
    let newData = {}
    newData[field] = temp;
    props.updateUserData(newData);
  }

  return (
    <div>
      <h3>What services are you interested in?</h3>
      <div style={{ textAlign: 'left' }}>
        {serviceOptions.map((serviceName, index) => (
          <div key={index}>
            <FormControlLabel
              control={
                <Switch
                  checked={selectedServices.includes(serviceName)}
                  onChange={() => handleToggle(serviceName)}
                  name={serviceName}
                  color="primary"
                />
              }
              key={index}
              label={serviceName}
            />
            <br /></div>))}
      </div>
    </div>
  );
}